/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface UiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get the UI page with a specific template or layout
     * Fetches the UI with a template or layout based on the query parameters provided.
     * @param template The template type to be used for the UI.
     * @param id The layout type to be used for the UI.
     */
    getUIStructure(template?: string, id?: string, extraHttpRequestParams?: any): Observable<string>;

}
